document.querySelectorAll('.RealtorsСhartList__list').forEach((container) => {
    tns({
        container,
        items: 2,
        slideBy: 2,
        controls: false,
        nav: true,
        mouseDrag: true,
        center: false,
        gutter: 10,
        loop: true,
        responsive: {
            768: {
                controls: true,
                nav: false,
                items: 6,
                slideBy: 3,
            }
        }
    });
});
